import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const DisplayMenuItem = urlConfig.DisplayMenuItem;

export const getMenusItemData = async (params: any) => {
  try {
    const response = await postCall(DisplayMenuItem, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
